import React, { useState, useEffect } from 'react';
import { Button, Table } from 'react-bootstrap';
import TablePaginationBar from './TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import formatDate from '../utils/formatDate';

const ChangeRequestTable = (data) => {
  const [render, setRender] = useState(null);
  const [currentUsers, setCurrentUsers] = useState(null);
  const [users, setUsers] = useState([]); // List of users
  const [search, setSearch] = useState(''); // Search input value
  const [filter, setFilter] = useState(''); // Filter value
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [usersPerPage] = useState(10); // Number of users per page

  // Pagination
  useEffect(() => {
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    setCurrentUsers(users.slice(indexOfFirstUser, indexOfLastUser));
  }, [render]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  // Filter and search
  useEffect(() => {
    let filteredUsers = data.data;

    if (filter === 'Sort by Name') {
      filteredUsers = data.data.sort((a, b) =>
        a.user.firstName > b.user.firstName ? 1 : -1
      );
    } else if (filter === 'Sort by Request Date') {
      filteredUsers = data.data.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateA - dateB;
      });
    }

    if (search) {
      filteredUsers = filteredUsers.filter((user) =>
        Object.values(user)
          .join(' ')
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }
    setUsers(filteredUsers);
    setRender(Math.floor(Math.random() * 10));
  }, [search, filter, data]);
  const navigate = useNavigate();

  return (
    <div className='container'>
      <div className='d-flex justify-content-end align-items-center '>
        <div className='me-2'>
          <input
            type='text'
            className='form-control rounded'
            placeholder='Search by Reason'
            style={{ maxWidth: '300px' }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <select
            className='form-select'
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value=''>Select Filter</option>
            <option value='Sort by Name'>Sort by Name</option>
            <option value='Sort by Request Date'>Sort by Request Date</option>
          </select>
        </div>
      </div>
      <div className='bg-white my-4 rounded shadow'>
        <table
          responsive='xl'
          className='table table-hover mb-4'
          style={{ borderCollapse: 'separate', borderSpacing: '0 1rem' }}
        >
          <thead className='bg-light'>
            <tr>
              <th>User</th>
              <th>Reason</th>
              <th>Request Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers?.map((user) => (
              <tr key={user._id}>
                <td>
                  {user.user.firstName}
                  {' ' + user.user.lastName}
                </td>
                <td>{user.reason}</td>
                <td>{formatDate(user.createdAt)}</td>
                <td>
                  <Button
                    variant='secondary'
                    size='md'
                    class='btn btn-secondary '
                    type='button'
                    id='dropdownMenuButton1'
                    data-bs-toggle='dropdown'
                  >
                    <BsThreeDots />
                  </Button>
                  <ul
                    class='dropdown-menu'
                    aria-labelledby='dropdownMenuButton1'
                  >
                    <li>
                      <a class='dropdown-item' href='#'>
                        Reasign
                      </a>
                    </li>
                    <li>
                      <a class='dropdown-item' href='#'>
                        Delete
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePaginationBar
        currentPage={currentPage}
        totalItems={users.length}
        rowsPerPage={usersPerPage}
        onPageChange={paginate}
      />
    </div>
  );
};

export default ChangeRequestTable;
